import { action, computed, makeObservable, observable } from 'mobx';

import { ProviderUid } from '@gem/call/CallProviders/callProviders.types';
import { Call } from '@gem/call/CallStore/Call';
import { Opponent } from '@gem/call/CallStore/Opponent/Opponent';

// TODO: [B2B-CALLS] - перевести отображение мемберов-блюр панели-оппонентов на другую логику с сеттером активного режима.
// TODO: [B2B-CALLS] - вся эта логика должна перейти селекторы на хуках или локальных сторах
export class ViewState {
  call: Call;
  @observable backgroundPanelShown = false;
  @observable isMembersShown = false;
  @observable isPermissionsRequestsShown = false;
  @observable canShowCompactView = false;
  @observable activeUid = null;
  @observable isGridLayout = true;
  @observable isFullScreenValue = true;
  @observable isWaitingAudioShow = false;
  @observable isWaitingAudioButtonShow = false;
  @observable lastActiveOpponentUid: ProviderUid | null = null;

  constructor(call: Call) {
    makeObservable(this);
    this.call = call;
  }

  @computed
  get speakerOpponent(): Opponent {
    if (this.isGridLayout) {
      return this.call.opponents.opponentList[0] || null;
    }

    const screenSharingOpponent = this.call.opponents.screenSharingOpponent;
    if (screenSharingOpponent) {
      return screenSharingOpponent;
    }

    const positions = this.call.opponentsPositions.opponentsPositions;
    const opponents = this.call.opponents.opponentList
      .filter((opponent) => {
        return !opponent.memberDevice?.isMyDevice;
      })
      .sort((a, b) => {
        const posA = positions[a.uid] ?? Infinity;
        const posB = positions[b.uid] ?? Infinity;
        return posA - posB;
      });

    const activeOpponent = opponents[0];
    if (activeOpponent) {
      this.lastActiveOpponentUid = activeOpponent.uid;
      return activeOpponent;
    }

    if (this.lastActiveOpponentUid) {
      const lastActive = opponents.find((opp) => opp.uid === this.lastActiveOpponentUid);
      if (lastActive) {
        return lastActive;
      }
    }

    return opponents[0] || null;
  }

  @computed
  get previewOpponents(): Opponent[] {
    return this.call.opponents.opponentList.filter((opponent) => opponent !== this.speakerOpponent);
  }

  @computed
  get hasPreviewOpponents(): boolean {
    return this.previewOpponents.length > 0;
  }

  @action
  setActiveOpponent(opponent: Opponent | null): void {
    if (opponent && !this.isGridLayout) {
      return;
    }

    if (opponent) {
      this.call.activeOpponentUid = opponent.uid;
    }
  }

  @action
  setIsWaitingAudioShow(isWaiting: boolean): void {
    this.isWaitingAudioShow = isWaiting;
  }

  @action
  setIsWaitingAudioButtonShow(isWaiting: boolean): void {
    this.isWaitingAudioButtonShow = isWaiting;
  }

  @action
  toggleGridLayout(opponent: Opponent | null): void {
    this.isGridLayout = !this.isGridLayout;
    if (this.isGridLayout) {
      this.call.activeOpponentUid = null;
    } else {
      if (opponent?.uid) {
        this.call.activeOpponentUid = opponent.uid;
        return;
      }

      const speaker = this.speakerOpponent;
      if (speaker?.uid) {
        this.call.activeOpponentUid = speaker.uid;
      }
    }
  }

  /**
   *  Members right panel
   */
  @action
  showMembers(): void {
    this.isMembersShown = true;
  }

  @action
  hideMembers(): void {
    this.isMembersShown = false;
  }

  @action
  toggleMembers(): void {
    if (this.isMembersShown) {
      this.hideMembers();
    } else {
      this.showMembers();
    }
  }

  showPermissionsRequests(): void {
    this.isPermissionsRequestsShown = true;
  }

  hidePermissionsRequests(): void {
    this.isPermissionsRequestsShown = false;
  }

  togglePermissionsRequests(): void {
    if (this.isPermissionsRequestsShown) {
      this.hidePermissionsRequests();
    } else {
      this.showPermissionsRequests();
    }
  }
  /**
   *  Call view Mode (FullScreen, Minimized, Compact)
   */
  @computed
  get isMinimized(): boolean {
    return !this.isFullScreenValue && !this.canShowCompactView;
  }

  @computed
  get isCompact(): boolean {
    return !this.isFullScreenValue && this.canShowCompactView;
  }

  @computed
  get isFullScreen(): boolean {
    return this.isFullScreenValue;
  }

  @action
  collapse(): void {
    this.isFullScreenValue = false;
  }

  @action
  expand(): void {
    this.isFullScreenValue = true;
  }

  setCanShowCompactView(value: boolean): void {
    this.canShowCompactView = value;
  }

  @action
  hideBackgroundPanel(): void {
    this.backgroundPanelShown = false;
  }

  @action
  showBackgroundPanel(): void {
    this.backgroundPanelShown = true;
  }

  @action
  toggleBackgroundPanel(): void {
    if (this.backgroundPanelShown) {
      this.hideBackgroundPanel();
    } else {
      this.showBackgroundPanel();
    }
  }
}
